import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SignupService } from 'src/app/services/core/signup/signup.service';
import { imageProcessing, ImageSnippet } from 'src/app/utils/image-processing-utils';
import { sweetAlert } from 'src/app/utils/swal';
import {states, uploadDocumentImages, phoneNumberLengthValidator, allowOnlyNumbersValidator } from 'src/app/utils/utils.common';
import * as moment from 'moment-timezone';
import { UploadService } from 'src/app/services/core/documents/upload.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { urls } from 'src/app/utils/url.utils';
import { UpperCasePipe } from '@angular/common';
import { validateFileSize } from 'src/app/utils/common.utils';
import { addressValidator } from 'src/app/utils/custom-validators';

@UntilDestroy()

@Component({
  selector: 'app-add-signup',
  templateUrl: './add-signup.component.html',
  styleUrls: ['./add-signup.component.css']
})
export class AddSignupComponent implements OnInit {

  signupfrom!: FormGroup
  submitted = false;
  selectedServices: any = '';
  states = states;
  status = true
  spacetypes:any
  profileImageURL: string | null = null; 
  selectedFile: ImageSnippet | null = null;
  timezones:any

  constructor(
    private signupService: SignupService,
    private router: Router,
    private uploadService: UploadService,
    private SpaceTypeService: SpaceTypeService,
    private fb: FormBuilder) { }

  ngOnInit(): void {
    this.getSpaceTypes()
    this.timezones = moment.tz.names();

    this.signupfrom = this.fb.group({
      name: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      phoneNumber: ['', [Validators.required, phoneNumberLengthValidator]],
      address : this.fb.group({
        name: ['', [Validators.required]],
        city: ['', [Validators.required]],
        coords : [[]],
        state : ['', Validators.required]
      }, { validators: addressValidator() }),
      profileImageURL: ['', Validators.required],
      type: ['company', Validators.required],
      timeZone: ['America/New_York', Validators.required],
      webURL: [''],
      services: [[''], Validators.required],
      fleet: ['', Validators.required],
      drivers: ['', Validators.required],
      contactNumber: ['', [phoneNumberLengthValidator]]
    },{
      validators: [
        allowOnlyNumbersValidator('phoneNumber'),
        allowOnlyNumbersValidator('contactNumber'),
      ]
    });

  }


  get form() {
    return this.signupfrom.controls;
  }

  get address() {
    return this.signupfrom.controls.address as FormGroup
  }

  onSave() {
    this.submitted = true;
    this.signupfrom.patchValue({
      services: this.selectedServices 
    });
    if (this.signupfrom.invalid) {
      return;
    }
    const payload = this.signupfrom.value;

    this.signupService.signup(payload).pipe(untilDestroyed(this)).subscribe(
      (data) => {
        if (data) {
          this.router.navigateByUrl("signups");
        }
      },
      (err) => {
        sweetAlert("Error", err, "error", "OK");
      }
    );

  }

  onSelectAddress(place: any): void {
    const selectedAddress = place.address_components;
    const city = selectedAddress.find((data: any) =>
      data.types.includes('locality') || data.types.includes('administrative_area_level_2')
    );
    const cityName = city ? city.long_name : '';
    const state = selectedAddress.find((data: any) =>
      data.types.includes('administrative_area_level_1')
    );
    console.log("stateName",state)

    const stateName = state ? state.long_name : '';
    this.signupfrom.patchValue({
      address: {
        city: cityName,
        state: stateName,
        name: place.formatted_address,
        coords: [
          place.geometry.location.lng(),
          place.geometry.location.lat()
        ]
        // state: place.address_components.find(comp => comp.types.includes('administrative_area_level_1'))?.short_name // assuming 'state' is part of the address components
      }
    });


  }

  toggleServiceSelection(title: any) {
    const index = this.selectedServices.indexOf(title);
    if (index === -1) {
      this.selectedServices = [...this.selectedServices, title];
    } else {
      this.selectedServices = this.selectedServices.filter((t:any) => t !== title);
    }
  }


  getSpaceTypes() {
    const queryParams = {
      limit: 9999,
      isActive: this.status
    }
    this.SpaceTypeService.getPicker(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.spacetypes = data.results.map((item: any) => {
          return {
            ...item,
            title: new UpperCasePipe().transform(item.title)
          };
        });
      }
    })
  }

  processFile(imageInput: any) {
    const file = imageInput.files?.[0];
   if (!validateFileSize(file)) {
         return;
       }
    imageProcessing(imageInput).pipe(untilDestroyed(this)).subscribe({
      next: (result) => {
        this.selectedFile = result.file;
        if (!this.selectedFile || !(this.selectedFile instanceof Blob)) {
          return;
        }
        this.uploadService.uploadImageToServer(this.selectedFile, urls.SIGNUPS).pipe(untilDestroyed(this)).subscribe({
          next: (uploadResult: any) => {
            if (uploadResult?.fileUrl) {
              this.signupfrom.get('profileImageURL')?.setValue(uploadResult.fileUrl);
              this.profileImageURL = uploadResult.fileUrl;
            }
          },
        });
      },
      error: (processingError) => {
        console.error('Error processing image:', processingError);
      },
    });
  }

   uploadDocumentImages(documents: any, formControl: AbstractControl<any, any> | null) {
      uploadDocumentImages(documents, formControl, this.uploadService, urls.SIGNUPS)
    }

  onChangeAddress() {
    this.signupfrom.patchValue({
      address: {
        city: '',
        state: '',
        coords: ''
      }
    })
  }

}
